import React from 'react';

import Accordion from 'xgimi-ui/mui/material/Accordion';
import AccordionSummary from 'xgimi-ui/mui/material/AccordionSummary';
import AccordionDetails from 'xgimi-ui/mui/material/AccordionDetails';
import Icon, { icons } from 'xgimi-ui/Icon';
import Base from 'xgimi-ui/BaseComponent';

import s from './.module.scss';

interface Props {
  // 是否默认展开
  isDefaultExpand?: boolean;
  // 标题
  title: string;
  // 日期
  date: string;
}

interface State {
  // 是否展开
  isExpand: boolean;
}

/**
 * 展开面板
 */
export default class extends Base<Props, State> {
  static defaultProps = {

  };

  state: State = {
    isExpand: !!this.props.isDefaultExpand,
  };

  render(): React.ReactNode {
    return (
      <Accordion
        className={this.getClassName()}
        classes={{ root: s.root }}
        expanded={this.state.isExpand}
        onChange={() => this.setState((preState) => ({ isExpand: !preState.isExpand }))}
        elevation={0}
      >
        <AccordionSummary classes={{ root: s.container, content: s.content }} expandIcon={<span className={s.icon}><Icon type={icons.ExpandMore} /></span>} >
          <div>
            <div className={s.title}>{this.props.title}</div>
            <div className={s.date}>{this.props.date}</div>
          </div>
        </AccordionSummary>
        <AccordionDetails classes={{ root: s.detail }}>
          {this.props.children}
        </AccordionDetails>
      </Accordion>
    );
  }
}
